<template>
  <div class="w-full h-full relative">

    <O3D :px="0" :pz="10" :py="50">
      <PointLight :decay="2" :distance="0" :color="0xffffff" :helper="isDev && isOff" :intensity="0.4"></PointLight>
    </O3D>

    <O3D :px="0" :pz="-10" :py="18">
      <PointLight :decay="2" :distance="0" :color="0xffffff" :helper="isDev && isOff" :intensity="0.4"></PointLight>
    </O3D>

    <O3D :px="20" :pz="20" :py="10">
      <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
    </O3D>

    <O3D :px="-20" :pz="20" :py="10">
      <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
    </O3D>

    <O3D :px="20" :pz="-20" :py="10">
      <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
    </O3D>

    <O3D :px="-20" :pz="-20" :py="10">
      <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
    </O3D>

    <O3D :px="0" :pz="0" :py="0">
      <AmbinetLight :color="0xffffff" :helper="isDev && isOff" :intensity="0.2"></AmbinetLight>
    </O3D>

    <ComputeResource v-if="ctx.renderer" :enable="['chroma']">
      <SwatWalk></SwatWalk>
      <slot @lookAtGuy="lookAtGuy = $event"></slot>
    </ComputeResource>

    <!-- <O3D :py="-13">
      <CamControl :hideMenu="true" :canTune="false"></CamControl>
    </O3D> -->
    <!-- <Game :nolight="true"></Game> -->
  </div>
</template>

<script>
import { Scene, Vector3, Object3D } from 'three'
import { PCamera } from '../../Reusable/PCamera'
import { getScreen } from '../../Reusable/O3DG2'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
export default {
  mixins: [
    require('../../Reusable/RenderRoot').RenderRoot
  ],
  data () {
    return {
      lookAtGuy: false,
      screen: false,
      scene: false,
      camera: false
    }
  },
  created () {
    this.$on('lookAtGuy', (v) => {
      let o3 = new Object3D()
      v.add(o3)
      o3.position.y -= 10
      this.lookAtGuy = o3
      console.log(v)
    })
  },
  methods: {
    async setupGraphics () {
      this.scene = new Scene()
      this.camera = new PCamera({ element: this.ctx.element, onResize: this.onResize })
      this.o3d.add(this.camera)

      let charLookAtTargetLast = new Vector3()
      let charLookAtTargetTemp = new Vector3()
      let charLookAtTarget = new Vector3(0, 13, 0)
      this.camera.position.z = 20
      this.camera.position.y = 0
      this.controls = new OrbitControls(this.camera, this.ctx.element)

      this.onLoop(() => {
        if (this.lookAtGuy) {
          this.controls.update()
          this.lookAtGuy.updateMatrix()
          this.lookAtGuy.updateMatrixWorld()
          this.lookAtGuy.updateWorldMatrix()
          charLookAtTarget.setFromMatrixPosition(this.lookAtGuy.matrixWorld)

          let diff = charLookAtTargetTemp.copy(charLookAtTargetLast).sub(charLookAtTarget).multiplyScalar(-1)
          this.controls.object.position.add(diff)

          charLookAtTargetLast.copy(charLookAtTarget)

          this.controls.target0.lerp(charLookAtTarget, 0.5)
          this.controls.target.lerp(charLookAtTarget, 0.5)
          this.controls.saveState()
        }
      })

      this.$emit('onLoop', this.onLoop)

      this.onResize(() => {
        this.screen = getScreen({ camera: this.camera, depth: this.camera.position.z })
      })
      this.scene.add(this.o3d)

      this.$emit('vm', this)
    }
  },
  mounted () {
    this.setupGraphics()
  }
}
</script>

<style>
</style>
